/*
 * @Author: your name
 * @Date: 2021-07-26 18:25:46
 * @LastEditTime: 2021-07-29 20:05:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\service\config.js
 */
import http from 'http'
import https from 'https'

export default {
  // 自定义的请求头
  headers: {
    // 'X-Requested-With': 'XMLHttpRequest',
    // 'X-Agent': 'Juejin/Web'
  },
  // 超时设置
  timeout: 600000,
  // 跨域是否带Token
  // withCredentials: true,
  // 响应的数据格式 json / blob /document /arraybuffer / text / stream
  responseType: 'json',
  // XSRF 设置
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  // 用于node.js
  httpAgent: new http.Agent({
    keepAlive: true
  }),
  httpsAgent: new https.Agent({
    keepAlive: true
  })
}